<style lang="scss" scoped>
@import '$vars';

.dropdown {
  &__secretary {
    * {
      letter-spacing: initial !important;
      text-transform: initial !important;
    }
    label {
      margin: 0;
      padding: 0;
      input {
        display: none;
      }
    }
    margin-left: 4em;
    li {
      padding: 0.5em 1em;
      border-bottom: 1px solid #999;
      &:last-child {
        border-bottom: 0
      }
    }
    .menu {
      display: block;
    }
    figure {
      img {
        height: 40px;
        margin-right: 10px;
      }
      figcaption {
        small {
          color: #666;
        }
        strong {
          color: black;
          white-space: nowrap;
          max-width: 200px;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
    }
  }
  &__doctor {
    label {
      text-transform: initial !important;
      letter-spacing: 0;
      >a {
        display: flex;
        align-items: center;
        padding-right: 0;
        padding-left: 0;
        padding: 0 !important;
        line-height: 1;

        i {
          // border: 1px solid green;
          margin: 0 0 0 0.3rem;
          padding: 0;
        }
      }
    }
    // margin-right: 2em;
    .menu {
      display: block;
      width: 300px;
      color: black;
        >figure {
        width: 100%;
        padding: 10px;
        box-sizing: border-box;
        margin-bottom: -10px;
          img {
            width: 75px;
            height: 75px;
            border-radius: 5px;
            margin-right: 10px;
          }
          figcaption {
            box-sizing: border-box;
            display: inline-flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            width: 75%;
            .user-name {
              white-space: nowrap;
            }
            p {
              margin: 5px 0 ;
              color: #999
            }
          }
          p {
            margin: 0;
            padding: 0;
          }
          h5 {
            font-size: 1.4em;
          }
          h5 , a  {
            margin-bottom: 5px
          }
        }
        .nav {
          li {
            width: 100%;
            a {
              display: block;
              width: 100%;
              padding: 5px 10px;
              &.active {
                color: $color-green;
                * {
                  fill: $color-green !important
                }
              }
              &:hover {
                color: $color-blue !important
              }
            }
            .route-icon {
              width: 20px;
              height: 20px;
              margin-right: 15px
            }
          }
        }
      }
    }
    >.btn {
      padding: 0;
    }
}

ul.nav {
  li {
    a {
      display: flex !important;
      flex-direction: row;

      figure {
        max-width: 20px;
        margin-right: 15px;
      }
    }
    .logout{
      padding-left: 45px !important;
    }
  }
}

#menu_help {
  display: none;
}

.text-capitalize {
  align-items: center;
  display: flex;
  margin-top: 0;
  justify-content: center;
  text-transform: none !important;
}

.no-underline {
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }
}

.menu-help {
  border-radius: 4px;
  margin: 0;
  min-width: 12rem;
  padding: 0.4rem;
  text-transform: none !important;
  width: max-content;

  & &__title {
    border-bottom: 1px solid rgb(227, 227, 227);
    text-transform: none !important;

    span {
      color: rgb(153, 153, 153);
      display: block;
      font-weight: 600;
      letter-spacing: 0 !important;
      padding: 0.2rem 0.4rem;
      text-align: left;
      text-transform: none !important;
      width: 100%;
    }
  }

  & li {
    cursor: pointer;
    color: darken(rgb(125, 125, 125), 20%);
    color: $gray-color;
    height: fit-content;
    margin: 0 0 0.5rem 0;
    padding: 0;
    text-align: left !important;
    text-transform: none !important;
    transition: 0.2s ease all;

    & a {
      letter-spacing: 0 !important;
      text-align: left;
      text-transform: none !important;
      width: 100%;
    }

    &:hover {
      transition: 0.2s ease all;
    }
  }
}

.tutorial-icon {
  width: 1rem;
}

.app-integration-menu-item {
  display: block;
  margin-right: 0.9rem;
  padding-left: 0.1rem;
  width: 1rem;

  &__icon {
    width: 15px !important;
  }
}
</style>

<template>
  <header class="header">
    <tutorial
      v-if="showTutorial"
      v-click-outside="closeTutorial"
      @close="closeTutorial"
    />

    <secretary-menu
      v-if="fn_IS_SECRETARY()"
      v-click-outside="() => toggleDoctorList = false"
      :doctor="doctor"
      :doctor-list="doctorList.filter(d => d.id !== doctor.id)"
    />

    <div class="header__logo" v-if="getSidebarToggled">
      <dr-vector
        fill="gradient"
        src="@/assets/img/Logo.svg"
      />
    </div>

    <div class="header__nav header__nav--left">
      <div
        v-if="fn_IS_DOCTOR()"
        class="header__subscription"
      >
        <strong>Plano:</strong>

        <router-link
          to="/doctor/plans"
          class="ml-2 text-underline text-uppercase font-semibold font-underline text-gray"
        >
          <span>{{currentPlan.display_name.toLowerCase()}}</span>
        </router-link>
      </div>

      <dr-toggle-telemedicine v-if="false && offices.length > 0" />
    </div>

    <div class="header__nav header__nav--right">
      <dr-office-select v-if="offices.length > 0" />

      <div class="help">
        <label for="menu_help" class="dropdown dropdown-right active">
          <input id="menu_help" type="checkbox" class="hide" v-model="toggleHelp" />

          <dr-icon style="width: 30px" class="clickable" name="help" color="#111"></dr-icon>

          <ul
            v-if="toggleHelp"
            v-click-outside="closeHelp"
            class="menu menu-help nav"
          >
            <li class="menu-help__title">
              <span>Tutoriais</span>
            </li>

            <li class="nav-item">
              <a target="_blank" href="https://cm2tech.zendesk.com/hc/pt-br/sections/4408560758804-FAQ-Perguntas-Frequentes-M%C3%A9dicos">
                <dr-icon
                  fill="blue"
                  name="help"
                  class="tutorial-icon"
                />

                FAQ
              </a>
            </li>
          </ul>
        </label>
      </div>

      <notifications v-if="false" />

      <div class="dropdown dropdown__doctor dropdown-right" >
        <label for="profile" id="TOUR_PROFILE">
          <input type="checkbox" class="hide" id="profile" v-model="toggleProfile" />

          <a class="btn btn-link btn-transparent">
            <template v-if="profile.displayName">
              {{ profile.displayName }}
            </template>
            <template v-else>
              {{ profile.name | TO_SHORT_NAME }}
            </template>

            <i class="icon icon-caret"></i>
          </a>

          <div class="menu d-block" v-show="toggleProfile">
            <figure class="d-flex" @click="toggleProfile = false">
              <img :src="profile.picture" />

              <figcaption v-if="profile.name">
                <p>
                  <strong class="user-name">
                    <template v-if="profile.displayName">
                      {{ profile.displayName }}
                    </template>
                    <template v-else>
                      {{ profile.name | TO_SHORT_NAME }}
                    </template>
                  </strong>
                  <br />
                  <small>{{$store.getters.getUser}}</small>
                </p>

                <router-link :to="`/${fn_IS_DOCTOR() ? 'doctor' : 'secretary'}/user`">
                  <button @click="toggleProfile = false" class="btn btn-sm btn-primary">
                    Minha conta
                  </button>
                </router-link>
              </figcaption>
            </figure>

            <hr />

            <ul class="nav">
              <template  v-for="route of profileRoutes" >
                <li :key="route.name" class="nav-item"  v-if="fn_IS_DOCTOR()">
                  <router-link
                    @click.native="toggleProfile = false"
                    :class="fn_GET_PARENT_ROUTE(route, 'Doctor') === fn_GET_PARENT_ROUTE($route, 'Doctor') ? 'active' : ''"
                    :to="{name: route.name}">
                    <dr-icon
                      class="route-icon"
                      :name="route.meta.icon"
                      :fill="'blue'" ></dr-icon>
                    {{route.meta.title}}
                  </router-link>
                </li>
              </template>

              <!-- App Integration -->
              <li
                v-if="showIntegrationButton"
                class="nav-item"
              >
                <router-link
                  :to="{ name: 'DoctorAppIntegrationEducation' }"
                >
                  <div class="app-integration-menu-item">
                    <dr-icon
                      :fill="'blue'"
                      name="appIntegration"
                      class="route-icon app-integration-menu-item__icon"
                    />
                  </div>
                  Marketplace e Consultório Virtual
                </router-link>
              </li>

              <li class="nav-item">
                <a @click.prevent="$emit('toggle-tutorial', '0')">
                  <dr-icon
                    fill="blue"
                    name="usuarios"
                    class="tutorial-icon"
                  />

                  Tutoriais
                </a>
              </li>

              <li class="nav-item">
                <router-link :to="`/logout`" class="logout">
                 Sair
                </router-link>
              </li>
            </ul>
          </div>
        </label>
      </div>
    </div>
  </header>
</template>

<script>
import notifications from '@/components/notifications'
import secretaryMenu from '@/components/layout/secretaryMenu'
import DrOfficeSelect from '@/components/layout/setOffice/officeSelectHeader'
import DrToggleTelemedicine from '@/components/layout/appIntegration/toggleTelemedicine'
import { mapGetters } from 'vuex'

export default {
  components: {
    notifications,
    secretaryMenu,
    DrOfficeSelect,
    DrToggleTelemedicine
  },

  props: {
    doctor: {
      type: Object,
      required: true
    },
    doctorList: {
      type: [Array, Object],
      required: true
    },
    doctorId: {
      type: Number,
      required: false
    },
    profile: {
      type: Object,
      required: true
    },
    profileRoutes: {
      type: [Object, Array],
      required: true
    },
    outerToggleProfile: {
      type: [Boolean],
      required: false
    }
  },

  data () {
    return {
      currentPlan: null,
      toggleDoctorList: false,
      toggleProfile: false,
      toggleHelp: false,
      showTutorial: false,
      isMarketPlace: false
    }
  },

  computed: {
    ...mapGetters({
      offices: 'getOffices',
      appIntegration: 'getAppIntegration',
      getViewport: 'getViewport',
      getSidebarToggled: 'getIsSidebarToggled',
      plan: 'getPlan'
    }),

    showIntegrationButton () {
      return this.fn_IS_DOCTOR() &&
        this.appIntegration &&
        this.appIntegration['is_active']
    }
  },

  watch: {
    outerToggleProfile (next) {
      this.toggleProfile = false
    }
  },

  created () {
    this.checkHealthplaceRequirements()
      .then((status) => {
        this.isMarketPlace = status
      })
  },
  mounted () {
    this.getcurrentPlan()
  },
  methods: {
    getcurrentPlan () {
      const url = '/doctor/doctor_subscription_plan'

      this.$http
        .get(url, this.$store.getters.getAuthHeader)
        .then(response => {
          this.currentPlan = response.data.subscription_plan
        })
        .catch((err) => { return err })
    },
    toggleMobileSidebar (event) {
      this.$store.dispatch('setIsSidebarToggled', true)
    },
    closeTutorial (event) {
      this.showTutorial = false
    },
    closeHelp () {
      this.toggleHelp = false
    },

    checkHealthplaceRequirements () {
      const url = '/doctor/doctor_health_place/has_agenda_available'

      return new Promise((resolve) => {
        this.$http
          .get(url, this.$store.getters.getAuthHeader)
          .then((res) => {
            resolve(Boolean(res.data))
          })
          .catch(() => resolve(false))
      })
    }
  }
}
</script>
